import {useIntl} from "react-intl";
import {PopupElement, PopupProvider} from "../../UIElements";
import React from "react";
import {useSupportBotContext} from "./SupportBotData";
import BotCoordinatorSelector from "./BotCoordinatorSelector";
import {Bell, User} from "lucide-react";

const BotInformation = ({ botData, updateBotData }) => {
    const intl = useIntl();
    const { name, description, status, supportRequestTarget, coordinator } = botData;
    const { data: { supportRoles } } = useSupportBotContext()

    return (
        <>
            <h4>
                {intl.formatMessage({
                    id: 'survey.navigation.information',
                    defaultMessage: 'Information',
                })}
            </h4>
            <div>
                <label htmlFor={"bot-name"}>
                    {intl.formatMessage({
                        id: 'survey.information.name',
                        defaultMessage: 'Name',
                    })}
                </label>
                <input
                    type={"text"}
                    id={"bot-name"}
                    value={name || ""}
                    onChange={e => updateBotData("name", e.target.value)}
                    placeholder={intl.formatMessage({
                        id: 'botName.placeholder',
                        defaultMessage: 'Give a name for your bot',
                    })}
                />
            </div>
            <div>
                <label htmlFor={"bot-description"}>
                    {intl.formatMessage({
                        id: 'description',
                        defaultMessage: 'Description',
                    })}
                </label>
                <textarea
                    id={"bot-description"}
                    value={description || ""}
                    onChange={e => updateBotData("description", e.target.value)}
                    placeholder={intl.formatMessage({
                        id: 'botDescription.placeholder',
                        defaultMessage: 'Write a short description about the bot, and how it supports students.',
                    })}
                    rows={3}
                />
            </div>
            <div className={"survey-dropdown"}>
                <label htmlFor={"bot-role"}>
                    <Bell />
                    {intl.formatMessage({
                        id:'supportRequestTarget',
                        defaultMessage:'Target for Support Requests'
                    })}
                </label>
                <select
                    id={"bot-role"}
                    value={supportRequestTarget || ""}
                    onChange={e => updateBotData("supportRequestTarget", e.target.value)}
                    >
                    <option value={""}>
                        {intl.formatMessage({
                            defaultMessage:"Support Requests Disabled",
                            id:'supportRequestsDisabled',
                        })}
                    </option>
                    {Object.keys(supportRoles[0]).map((role,i) => {
                        return <option key={i} value={role}>
                            {intl.formatMessage({
                                defaultMessage: role,
                                id: `role.${role}`,
                            })}
                        </option>
                    })}
                </select>
            </div>
            <div className={"flex column"}>
                <label htmlFor={"bot-coordinator"}>
                    <User />
                    {intl.formatMessage({
                        id:'botCoordinator',
                        defaultMessage:'Bottivastaava'
                    })}
                </label>
                <BotCoordinatorSelector
                    id={"bot-coordinator"}
                    value={coordinator || ""}
                    onChange={value => updateBotData("coordinator", value)}
                />
            </div>
        </>
    );
};
export default BotInformation